import { getUser } from '@/lib/common';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { urls } from '@/urls';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export default function TwoFactorAuthSetup() {
  const [userData, setUserData] = useState<any>({});
  const [otpVal, setOtpVal] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const user = getUser();

  useEffect(() => {
    setLoading(true);
    setError('');

    fetchWrapper
      .get(urls.DevOps.getUserQrCode.replace(':id', `${user?.id}`))
      .then((data) => {
        setUserData(data);
      })
      .finally(() => setLoading(false))
      .catch((err) => setError(String(err)));
  }, [user?.id]);

  const checkAndAddCode = () => {
    setError('');
    setLoading(true);

    fetchWrapper
      .post(urls.DevOps.setUser2FA, {
        id: user?.id,
        code: otpVal,
        secret: userData.secret,
      })
      .then(() => {
        setUserData({ hasBeenSetUp: true });
      })
      .finally(() => setLoading(false))
      .catch(() => setError('Wrong code provided.'));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}>
      {!loading && !userData.hasBeenSetUp && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 360,
          }}>
          <Typography variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
            Scan the below code using authenticator app and enter the generated
            code.
          </Typography>

          {userData.qrcode && (
            <Box
              component="img"
              src={userData.qrcode}
              alt="QR code"
              sx={{ display: 'block', mb: 2, maxWidth: '100%' }}
            />
          )}

          <TextField
            disabled={loading}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
            placeholder="Enter the code here"
            type="text"
            value={otpVal}
            onChange={(e) => setOtpVal(e.target.value)}
          />
          <Button
            disabled={loading || !otpVal}
            variant="contained"
            onClick={checkAndAddCode}>
            Add 2FA to your account
          </Button>

          {error && (
            <Alert sx={{ mt: 3, width: '100%' }} severity="error">
              {error}
            </Alert>
          )}
        </Box>
      )}
      {!loading && userData.hasBeenSetUp && (
        <Alert sx={{ width: '100%', maxWidth: 480 }} severity="success">
          Your two factor authentication is already set up. Good job!
        </Alert>
      )}
    </Box>
  );
}
